/**
 * Anvil &amp; Ash Training Essentials - Curated Affiliate Product Catalog
 * Amazon Associates Tag: anvilash-20
 *
 * Uses stock photos from Unsplash/Pexels for product images (TOS-compliant).
 * Affiliate links use direct Amazon ASIN links with associate tag.
 */

const ASSOCIATE_TAG = "anvilash-20";

export const getAmazonLink = (searchTerm) =>
  `https://www.amazon.com/s?k=${encodeURIComponent(searchTerm)}&tag=${ASSOCIATE_TAG}`;

export const getAmazonDirectLink = (asin) =>
  asin ? `https://www.amazon.com/dp/${asin}?tag=${ASSOCIATE_TAG}` : null;

const products = [
  // ======================== PROTEIN & SUPPLEMENTS ========================
  {
    id: "whey-gold-standard",
    name: "Optimum Nutrition Gold Standard Whey",
    description: "24g protein per serving. The world's best-selling whey protein powder.",
    category: "supplements",
    subcategory: "Protein",
    asin: "B000QSNYGI",
    imageUrl: "https://images.unsplash.com/photo-1693996045899-7cf0ac0229c7?w=400&h=400&fit=crop",
    searchTerm: "whey protein powder",
    priceRange: "$27–$60",
    rating: 4.7,
    tags: ["protein", "recovery", "muscle", "post-workout"],
    contextTriggers: ["low_protein", "post_workout", "muscle_building"],
  },
  {
    id: "creatine-monohydrate",
    name: "Optimum Nutrition Micronized Creatine",
    description: "5g pure creatine monohydrate. Supports strength and power output.",
    category: "supplements",
    subcategory: "Performance",
    asin: "B002DYIZEO",
    imageUrl: "https://images.unsplash.com/photo-1768161680813-615df885ff82?w=400&h=400&fit=crop",
    searchTerm: "creatine monohydrate powder",
    priceRange: "$15–$36",
    rating: 4.7,
    tags: ["strength", "power", "creatine", "performance"],
    contextTriggers: ["strength_training", "gym"],
  },
  {
    id: "pre-workout",
    name: "Gorilla Mode Pre-Workout",
    description: "Mega-dosed with L-Citrulline, creatine, and betaine for insane pumps and focus.",
    category: "supplements",
    subcategory: "Pre-Workout",
    asin: "B078SJ9F5S",
    imageUrl: "https://images.unsplash.com/photo-1704650311162-153bbf7f17b0?w=400&h=400&fit=crop",
    searchTerm: "pre workout powder",
    priceRange: "$39–$49",
    rating: 4.5,
    tags: ["energy", "pre-workout", "focus", "pump"],
    contextTriggers: ["pre_workout"],
  },
  {
    id: "protein-bars-quest",
    name: "Quest Nutrition Protein Bars",
    description: "20g protein, 1g sugar. Clean fuel for training days on the go.",
    category: "supplements",
    subcategory: "Protein",
    asin: "B00DLDH1N2",
    imageUrl: "https://images.pexels.com/photos/6208145/pexels-photo-6208145.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "protein bars high protein low sugar",
    priceRange: "$23–$28",
    rating: 4.5,
    tags: ["protein", "snack", "low-sugar", "convenient"],
    contextTriggers: ["low_protein", "nutrition"],
  },
  {
    id: "bcaa-xtend",
    name: "XTEND BCAA Powder",
    description: "7g BCAAs per serving. Hydration and recovery support.",
    category: "supplements",
    subcategory: "Recovery",
    asin: "B005CH0DT4",
    imageUrl: "https://images.unsplash.com/photo-1709976142402-0ce49c22dbfc?w=400&h=400&fit=crop",
    searchTerm: "BCAA powder recovery",
    priceRange: "$20–$25",
    rating: 4.6,
    tags: ["bcaa", "recovery", "hydration", "amino-acids"],
    contextTriggers: ["post_workout", "recovery"],
  },
  {
    id: "fish-oil-nordic",
    name: "Nordic Naturals Ultimate Omega",
    description: "1280mg Omega-3. Supports heart, brain, and joint health.",
    category: "supplements",
    subcategory: "Health",
    asin: "B002CQU564",
    imageUrl: "https://images.pexels.com/photos/208518/pexels-photo-208518.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "omega 3 fish oil supplement",
    priceRange: "$28–$45",
    rating: 4.7,
    tags: ["omega-3", "joints", "health", "recovery"],
    contextTriggers: ["recovery", "health"],
  },

  // ======================== HOME EQUIPMENT ========================
  {
    id: "resistance-bands-set",
    name: "Fit Simplify Resistance Loop Bands",
    description: "5-band set with carry bag. Perfect for home workouts at any level.",
    category: "equipment",
    subcategory: "Resistance",
    asin: "B01AVDVHTI",
    imageUrl: "https://images.unsplash.com/photo-1584827386916-b5351d3ba34b?w=400&h=400&fit=crop",
    searchTerm: "resistance bands set exercise",
    priceRange: "$9–$13",
    rating: 4.5,
    tags: ["resistance-bands", "home", "beginner", "portable"],
    contextTriggers: ["home_workout", "beginner"],
  },
  {
    id: "pull-up-bar",
    name: "Perfect Fitness Multi-Gym Pull Up Bar",
    description: "Doorway mounted. Multiple grip positions for pull-ups, chin-ups, and sit-ups.",
    category: "equipment",
    subcategory: "Bars",
    asin: "B001EJMS6K",
    imageUrl: "https://images.pexels.com/photos/4803675/pexels-photo-4803675.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "doorway pull up bar",
    priceRange: "$25–$40",
    rating: 4.4,
    tags: ["pull-up", "home", "back", "upper-body"],
    contextTriggers: ["home_workout", "back_biceps"],
  },
  {
    id: "adjustable-dumbbells",
    name: "Bowflex SelectTech 552 Dumbbells",
    description: "Replaces 15 sets of weights. 5 to 52.5 lbs per hand.",
    category: "equipment",
    subcategory: "Weights",
    asin: "B001ARYU58",
    imageUrl: "https://images.pexels.com/photos/669580/pexels-photo-669580.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "adjustable dumbbells",
    priceRange: "$349–$429",
    rating: 4.7,
    tags: ["dumbbells", "home-gym", "adjustable", "strength"],
    contextTriggers: ["home_workout", "strength_training"],
  },
  {
    id: "yoga-mat",
    name: "BalanceFrom GoYoga All-Purpose Mat",
    description: "71\" x 24\", 1/2\" thick. High density anti-tear with carrying strap.",
    category: "equipment",
    subcategory: "Yoga & Recovery",
    asin: "B01LP0U5X0",
    imageUrl: "https://images.pexels.com/photos/4028197/pexels-photo-4028197.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "yoga mat thick cushion",
    priceRange: "$17–$25",
    rating: 4.5,
    tags: ["yoga", "mat", "recovery", "stretching"],
    contextTriggers: ["yoga", "recovery", "active_recovery"],
  },
  {
    id: "jump-rope",
    name: "Crossrope Get Lean Jump Rope Set",
    description: "Weighted jump ropes for cardio and conditioning.",
    category: "equipment",
    subcategory: "Cardio",
    asin: "B07D37V7LD",
    imageUrl: "https://images.unsplash.com/photo-1516876345887-6dd74f80787a?w=400&h=400&fit=crop",
    searchTerm: "weighted jump rope fitness",
    priceRange: "$54–$70",
    rating: 4.4,
    tags: ["cardio", "jump-rope", "conditioning", "home"],
    contextTriggers: ["cardio", "home_workout"],
  },
  {
    id: "kettlebell",
    name: "CAP Barbell Cast Iron Kettlebell",
    description: "Solid cast iron, enamel coating. Available in 10-80 lb sizes.",
    category: "equipment",
    subcategory: "Weights",
    asin: "B002OEQ50Y",
    imageUrl: "https://images.unsplash.com/photo-1686791789070-90949cfec4b6?w=400&h=400&fit=crop",
    searchTerm: "cast iron kettlebell",
    priceRange: "$15–$55",
    rating: 4.7,
    tags: ["kettlebell", "strength", "full-body", "home"],
    contextTriggers: ["home_workout", "full_body"],
  },
  {
    id: "treadmill",
    name: "Sunny Health & Fitness Folding Treadmill",
    description: "Compact foldable treadmill with incline settings. Perfect cardio warm-up for home training.",
    category: "equipment",
    subcategory: "Cardio",
    asin: "B08FB2JGFB",
    imageUrl: "https://images.unsplash.com/photo-1637714409323-d5e6e9731252?w=400&h=400&fit=crop",
    searchTerm: "foldable treadmill home gym",
    priceRange: "$250–$500",
    rating: 4.4,
    tags: ["treadmill", "cardio", "warm-up", "home-gym", "running"],
    contextTriggers: ["cardio", "home_workout", "warm_up"],
  },
  {
    id: "stationary-bike",
    name: "Sunny Health & Fitness Indoor Cycling Bike",
    description: "Heavy-duty flywheel, adjustable resistance, padded seat. Low-impact cardio for any fitness level.",
    category: "equipment",
    subcategory: "Cardio",
    asin: "B007595TKU",
    imageUrl: "https://images.pexels.com/photos/4162580/pexels-photo-4162580.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "indoor stationary exercise bike",
    priceRange: "$200–$350",
    rating: 4.4,
    tags: ["bike", "cycling", "cardio", "warm-up", "home-gym", "low-impact"],
    contextTriggers: ["cardio", "home_workout", "warm_up"],
  },
  {
    id: "rowing-machine",
    name: "Concept2 RowErg Rowing Machine",
    description: "The gold standard. Used by CrossFit gyms worldwide. Air resistance, PM5 monitor.",
    category: "equipment",
    subcategory: "Cardio",
    asin: "B00NH9WEUA",
    imageUrl: "",
    searchTerm: "rowing machine home gym",
    priceRange: "$300–$1000",
    rating: 4.7,
    tags: ["rowing", "cardio", "full-body", "warm-up", "home-gym", "conditioning"],
    contextTriggers: ["cardio", "home_workout", "warm_up", "full_body"],
  },

  // ======================== GYM ACCESSORIES ========================
  {
    id: "lifting-gloves",
    name: "Trideer Workout Gloves",
    description: "Full palm protection with wrist support. Breathable and durable.",
    category: "accessories",
    subcategory: "Gloves",
    asin: "B01H4OAPEA",
    imageUrl: "https://images.pexels.com/photos/669585/pexels-photo-669585.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "workout gloves gym",
    priceRange: "$10–$16",
    rating: 4.4,
    tags: ["gloves", "grip", "protection", "gym"],
    contextTriggers: ["gym", "strength_training"],
  },
  {
    id: "weightlifting-belt",
    name: "Harbinger Padded Leather Belt",
    description: "Padded leather, contoured fit. 4-inch support for squats and deadlifts.",
    category: "accessories",
    subcategory: "Support",
    asin: "B0011861UI",
    imageUrl: "https://images.unsplash.com/photo-1586232710888-675866d80ad2?w=400&h=400&fit=crop",
    searchTerm: "weightlifting belt leather",
    priceRange: "$25–$40",
    rating: 4.5,
    tags: ["belt", "support", "squat", "deadlift", "heavy"],
    contextTriggers: ["legs", "gym", "strength_training"],
  },
  {
    id: "wrist-wraps",
    name: "WOD Nation Wrist Wraps",
    description: "Heavy-duty 18\" wraps. Wrist stabilization for pressing movements.",
    category: "accessories",
    subcategory: "Support",
    asin: "B01LZ2SNIA",
    imageUrl: "",
    searchTerm: "wrist wraps weightlifting",
    priceRange: "$13–$17",
    rating: 4.5,
    tags: ["wrist", "support", "pressing", "bench"],
    contextTriggers: ["chest_triceps", "shoulders"],
  },
  {
    id: "shaker-bottle",
    name: "BlenderBottle Classic V2",
    description: "28oz with BlenderBall wire whisk. Smooth shakes every time.",
    category: "accessories",
    subcategory: "Nutrition",
    asin: "B0853D5GLP",
    imageUrl: "https://images.pexels.com/photos/4378521/pexels-photo-4378521.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "protein shaker bottle",
    priceRange: "$8–$12",
    rating: 4.7,
    tags: ["shaker", "protein", "nutrition", "convenient"],
    contextTriggers: ["nutrition", "supplements"],
  },
  {
    id: "gym-bag",
    name: "Under Armour Undeniable 5.0 Duffle",
    description: "Water-resistant, abrasion-resistant. Built for the daily grind.",
    category: "accessories",
    subcategory: "Bags",
    asin: "B08TWYF5P8",
    imageUrl: "https://images.unsplash.com/photo-1692506530242-c12d6c3ae2e2?w=400&h=400&fit=crop",
    searchTerm: "gym duffle bag",
    priceRange: "$35–$55",
    rating: 4.7,
    tags: ["bag", "gym", "carry", "storage"],
    contextTriggers: ["gym"],
  },

  // ======================== RECOVERY ========================
  {
    id: "foam-roller",
    name: "TriggerPoint GRID Foam Roller",
    description: "Multi-density surface for deep tissue massage and mobility.",
    category: "recovery",
    subcategory: "Massage",
    asin: "B0040EGNIU",
    imageUrl: "https://images.pexels.com/photos/6207519/pexels-photo-6207519.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "foam roller muscle recovery",
    priceRange: "$25–$37",
    rating: 4.6,
    tags: ["foam-roller", "mobility", "recovery", "massage"],
    contextTriggers: ["recovery", "post_workout", "active_recovery"],
  },
  {
    id: "massage-gun",
    name: "Theragun Relief Massage Gun",
    description: "Quiet, powerful percussion therapy. 3 speeds, ergonomic grip.",
    category: "recovery",
    subcategory: "Massage",
    asin: "B0BZK48Y4H",
    imageUrl: "https://images.pexels.com/photos/6388455/pexels-photo-6388455.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop",
    searchTerm: "massage gun percussion",
    priceRange: "$129–$149",
    rating: 4.5,
    tags: ["massage-gun", "percussion", "recovery", "soreness"],
    contextTriggers: ["recovery", "post_workout"],
  },
  {
    id: "compression-sleeves",
    name: "Mueller Elastic Knee Support",
    description: "Comfortable compression fit. Warmth and support for active knees.",
    category: "recovery",
    subcategory: "Compression",
    asin: "B002NLGNW8",
    imageUrl: "https://images.unsplash.com/photo-1658279584706-a5215c2c1ce2?w=400&h=400&fit=crop",
    searchTerm: "knee compression sleeves",
    priceRange: "$8–$14",
    rating: 4.4,
    tags: ["knee", "compression", "support", "legs"],
    contextTriggers: ["legs", "cardio", "recovery"],
  },
  {
    id: "lacrosse-ball",
    name: "TriggerPoint MBX Massage Ball",
    description: "Extra-firm texture for targeted deep-tissue release.",
    category: "recovery",
    subcategory: "Massage",
    asin: "B00ASNOH5U",
    imageUrl: "",
    searchTerm: "massage ball trigger point",
    priceRange: "$9–$14",
    rating: 4.5,
    tags: ["massage-ball", "trigger-point", "mobility", "recovery"],
    contextTriggers: ["recovery", "active_recovery"],
  },

  // ======================== APPAREL ========================
  {
    id: "workout-shorts",
    name: "BROKIG Gym Shorts",
    description: "5\" inseam, zippered pockets. Lightweight and breathable.",
    category: "apparel",
    subcategory: "Bottoms",
    asin: "B09MK3WFKW",
    imageUrl: "https://images.unsplash.com/photo-1680759170077-e9e2d838a34c?w=400&h=400&fit=crop",
    searchTerm: "mens gym shorts workout",
    priceRange: "$18–$24",
    rating: 4.4,
    tags: ["shorts", "gym", "breathable", "training"],
    contextTriggers: ["gym"],
  },
  {
    id: "training-shoes",
    name: "Nike Metcon 9",
    description: "Stable base for lifting, flexible for HIIT. A go-to training shoe.",
    category: "apparel",
    subcategory: "Footwear",
    asin: "B0C2F63T2N",
    imageUrl: "https://images.unsplash.com/photo-1607327517118-f4c71e191548?w=400&h=400&fit=crop",
    searchTerm: "Nike Metcon training shoes",
    priceRange: "$130–$150",
    rating: 4.6,
    tags: ["shoes", "training", "lifting", "crossfit"],
    contextTriggers: ["gym", "strength_training"],
  },
];

// Category metadata for display
export const categories = [
  { id: "supplements", name: "Protein & Supplements", icon: "Flask", description: "Fuel your conquest" },
  { id: "equipment", name: "Home Gym Gear", icon: "Dumbbell", description: "Build your space" },
  { id: "accessories", name: "Battle Gear", icon: "Shield", description: "Equip for war" },
  { id: "recovery", name: "Recovery Tools", icon: "Heart", description: "Recover and rebuild" },
  { id: "apparel", name: "Training Apparel", icon: "Shirt", description: "Look the part" },
];

/**
 * Get products by category
 */
export const getProductsByCategory = (categoryId) =>
  products.filter((p) => p.category === categoryId);

/**
 * Get contextual recommendations based on triggers
 * @param {string[]} triggers - e.g. ['post_workout', 'low_protein', 'home_workout']
 * @param {number} limit - max products to return
 */
export const getRecommendations = (triggers, limit = 3) => {
  if (!triggers || triggers.length === 0) return products.slice(0, limit);

  const scored = products.map((p) => {
    const matchCount = p.contextTriggers.filter((t) => triggers.includes(t)).length;
    return { ...p, score: matchCount };
  });

  return scored
    .filter((p) => p.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);
};

/**
 * Get all products
 */
export const getAllProducts = () => products;

export default products;
